import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './components/Home.vue'
import Product from './components/Product.vue'
import AboutUs from './components/AboutUs.vue'
import Service from './components/Service.vue'
import PleaseNote from './components/PleaseNote.vue'
import ContactUs from './components/ContactUs.vue'

Vue.use(VueRouter)


export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {title: 'Home | Elizabeth'}
    },
    {
      path: '/products',
      name: 'products',
      component: Product,
      meta: {title: 'Product | Elizabeth'}
    },
     {
      path: '/about-us',
      name: 'about-us',
      component: AboutUs,
      meta: {title: 'About Us | Elizabeth'}
    },
    {
      path: '/services',
      name: 'services',
      component: Service,
      meta: {title: 'Service | Elizabeth'}
    },
    {
      path: '/please-note',
      name: 'please-note',
      component: PleaseNote,
      meta: {title: 'Please Note | Elizabeth'}
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUs,
      meta: {title: 'Contact Us | Elizabeth'}
    },
  ],
 // mode: 'history',
})